/**
 * withBase — prefix an app-internal absolute path with the deploy base path.
 *
 * React Router's <Link>, <Navigate> and useNavigate already honor `basename`,
 * so they need NO change. This helper is only for navigations/asset URLs that
 * bypass the router: window.location.* hard reloads and raw Notification/asset
 * URLs. import.meta.env.BASE_URL is '/' in dev/Cloudflare and '/portal/' in the
 * WordPress subdirectory build.
 *
 * @example withBase("/login") // '/login' in dev, '/portal/login' under /portal
 */
export function withBase(path: string): string {
  const base = import.meta.env.BASE_URL.replace(/\/$/, ""); // '' or '/portal'
  return `${base}${path.startsWith("/") ? path : `/${path}`}`;
}
